import React, { useCallback, useState } from 'react';
import { Button } from 'antd';
import IconLink from '../Icons/IconLink';
import get from 'lodash/get';
import './EventButton.less';

export type EventButtonProps = {
  type?: 'primary' | 'link' | 'default' | 'text' | 'dashed' | 'ghost';
  size?: 'small' | 'middle' | 'large';
  fullWidth?: boolean;
  reset?: boolean;
  group: any;
  getTrainingLink: (type: string, group: { member: { id: string } }) => any;
  getPlacementTestResultsForGroupMember: (params: any) => any;
};

const EventButton: React.FC<EventButtonProps> = ({
  size = 'middle',
  type = 'primary',
  fullWidth = false,
  reset = false,
  group,
  getTrainingLink,
  getPlacementTestResultsForGroupMember,
}) => {
  const newTypes = {
    reset: 'dashed',
    primary: 'primary',
    link: 'link',
    default: 'default',
    text: 'text',
    ghost: 'ghost',
  };
  const classNames = [
    't-button',
    `t-button-${newTypes[type]}`,
    `t-button-${size}`,
  ];
  if (fullWidth) {
    classNames.push('t-button-fullwidth');
  }
  if (reset) {
    classNames.push('t-button-reset');
  }

  const [disabled, setDisabled] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const getLinks = useCallback(
    async (type) => {
      const { link } = await getTrainingLink(type, group);
      if (!link) {
        setDisabled(true);
        return;
      }
      return link;
    },
    [getTrainingLink],
  );

  const setProps = () => {
    const buttonsProps = [];
    if (get(group, 'practice', false) && get(group, 'member')) {
      buttonsProps.push({
        title: 'Practice',
        color: '#f54e95',
        onButtonClick: async () =>
          await getPlacementTestResultsForGroupMember({
            groupId: group.id,
            userId: group.member.userId,
          }),
      });
    }
    if (get(group, 'customTrainingLink')) {
      buttonsProps.push({
        titletype: 'link',
        icon: <IconLink size="md" fill="#52AEFF" />,
        color: '#F7F7F8',
        type: 'link',
        onButtonClick: async () => await getLinks('custom'),
      });
      return buttonsProps;
    }
    if (get(group, 'apps.lessonspace.enable')) {
      buttonsProps.push({
        title: '',
        icon: <IconLink size="md" fill="#52AEFF" />,
        color: '#F7F7F8',
        type: 'link',
        onButtonClick: async () => await getLinks('lessonspace'),
      });
      return buttonsProps;
    }
    if (get(group, 'apps.zoom.enable')) {
      buttonsProps.push({
        title: '',
        icon: <IconLink size="md" fill="#52AEFF" />,
        color: '#F7F7F8',
        type: 'link',
        onButtonClick: async () => await getLinks('zoom'),
      });
      return buttonsProps;
    }
    if (get(group, 'apps.liveboard.enable')) {
      buttonsProps.push({
        title: '',
        icon: <IconLink size="md" fill="#52AEFF" />,
        color: '#F7F7F8',
        type: 'link',
        onButtonClick: async () => await getLinks('liveboard'),
      });
      return buttonsProps;
    }
    return buttonsProps;
  };
  const buttonsProps = setProps();

  return (
    <div className="event-buttons-container">
      {buttonsProps.map((buttonProps, index) => (
        <Button
          key={index}
          className={classNames.join(' ')}
          style={{
            backgroundColor: buttonProps.color,
            borderColor: buttonProps.color,
          }}
          type={buttonProps.type}
          loading={buttonLoading}
          disabled={disabled}
          icon={buttonProps.icon}
          onClick={async () => {
            setButtonLoading(true);
            let link = null;
            try {
              link = await buttonProps.onButtonClick();
            } catch (e) {
              setDisabled(true);
            } finally {
              setButtonLoading(false);
            }

            if (!link) {
              setDisabled(true);
              return;
            }
            window.location.href = link;
          }}
        >
          {buttonProps.title}
        </Button>
      ))}
    </div>
  );
};

export default EventButton;
